/**
 * TRF's published contact details (https://trf.org/contact-us).
 *
 * #3306 (Victor, 2026-10-26): the pre-screen appeal is gone. A family the
 * pre-screen stops reaches TRF by email or phone instead, so the stop screen
 * and the wizard's eligibility stop both show these. They are the
 * organisation's details, not form copy, so they are not a TRF-editable slot.
 */
export const TRF_CONTACT_EMAIL = 'info@trf.org';
/** As trf.org prints it. */
export const TRF_CONTACT_PHONE = '(725) 529-9035';
/** The same number for a `tel:` link. */
export const TRF_CONTACT_PHONE_TEL = '+17255299035';
